export default {

  // 新增原料供应商
  insertPaRawMaterials: '/ygsjzs/paRawMaterials/insertPaRawMaterials',
  //  修改原料供应商
  updatePaRawMaterials: '/ygsjzs/paRawMaterials/updatePaRawMaterials',
  // 删除原料供应商
  deletePaRawMaterials: '/ygsjzs/paRawMaterials/deletePaRawMaterials',

  // 查询原料供应商详情
  selectPaRawMaterialsByMaterialsId: '/ygsjzs/paRawMaterials/selectPaRawMaterialsByMaterialsId',
  // 查询原料供应商列表

  selectPaRawMaterialsByList: '/ygsjzs/paRawMaterials/selectPaRawMaterialsByList'
}
